// extracted by mini-css-extract-plugin
export default {"tableContainer":"VirtualTable-tableContainer-MHSuC","tableBodyContainer":"VirtualTable-tableBodyContainer-W0ddE"};